/* eslint-disable no-param-reassign */
import { useMemo } from 'react';
import { cast, types } from 'mobx-state-tree';
import type {
  Instance,
  SnapshotIn,
  SnapshotOut,
} from 'mobx-state-tree/dist/core/type/type';

import { AdmissionModel } from '@/models/admissions';
import { initializeStore } from '@/stores';
import type { AdmissionModelType } from '@/models/admissions';

export const AdmissionStore = types
  .model({
    admissions: types.array(AdmissionModel),
  })
  .views((self) => ({
    getAdmissionById(admissionId: number): AdmissionModelType | undefined {
      return self.admissions.find((a) => a.pk === admissionId);
    },
  }))
  .actions((self) => ({
    addAdmission(admission: AdmissionModelType) {
      if (admission && !self.admissions.some((a) => a.pk === admission.pk)) {
        self.admissions = cast([...self.admissions, admission]);
      }
    },
    increaseApplicationCounter(admissionId: number) {
      const admission = self.getAdmissionById(admissionId);
      admission?.stats.increaseAppliedCounter();
    },
    decreaseApplicationCounter(admissionId: number) {
      const admission = self.getAdmissionById(admissionId);
      admission?.stats.decreaseAppliedCounter();
    },
  }))
  .named('AdmissionStore');

export const useAdmissionStore = (
  initialState: AdmissionStoreSnapshotIn | null = null,
): AdmissionStoreType => {
  return useMemo(
    () => initializeStore(AdmissionStore, initialState),
    [initialState],
  );
};

export type AdmissionStoreType = Instance<typeof AdmissionStore> & {};

export type AdmissionStoreSnapshotIn = SnapshotIn<typeof AdmissionStore> & {};

export type AdmissionStoreSnapshotOut = SnapshotOut<typeof AdmissionStore> & {};
